// extracted by extract-css-chunks-webpack-plugin
module.exports = {"review-items-list":"review-items-list___iDqPZ","row":"row___2Fs7V","container":"container___2eCLn","label":"label___2s3vS","amount":"amount___2MmZA"};